export const NOTIFICATION_COPY = {
  title: '通知',
  deviceOnly: '只影響這部裝置，換一部機要再設定一次。',
  sound: '有新訊息時響一聲',
  soundHint: '分頁開着時，新對話分類到收件匣會發出提示聲。',
  desktopTitle: '桌面通知',
  desktopHint: '分頁在背景時，用系統通知提你有新訊息。',
  desktopEnable: '開啟桌面通知',
  desktopOn: '桌面通知已開啟。',
  desktopDenied: '瀏覽器已封鎖這個網站的通知。請到瀏覽器的網站設定允許通知，再回來這裡。',
  desktopUnsupported: '這個瀏覽器不支援桌面通知。',
  pushTitle: '推送通知',
  pushHint: '即使關閉了分頁或瀏覽器，也會收到新訊息通知。',
  pushEnable: '開啟推送通知',
  pushEnabling: '開啟中…',
  pushDisable: '關閉推送通知',
  pushDisabling: '關閉中…',
  pushOn: '推送通知已開啟。',
  pushUnavailable: '平台未設定推送通知，暫時未能使用。',
  pushUnsupported: '這個瀏覽器不支援推送通知。如果用 iPhone 或 iPad，請先把回覆助手加到主畫面。',
  pushDenied: '瀏覽器已封鎖這個網站的通知，所以未能開啟推送通知。',
  pushNotReady: '這部裝置未準備好接收推送通知，請重新載入頁面再試。',
  pushServiceDown: '瀏覽器暫時未能連接推送服務，請稍後再試。',
  pushFailed: '未能更改推送通知設定，請稍後再試。',
  loading: '載入中…',
} as const
